var config = {
    isGeodidalab: true,
}

var varOmekaIDsGeodidalab = {
    omekaIDattivita: 130,
    omekaIDtipologiaAttivita: 131,
    omekaIDluoghi: 134,
    omekaIDpoiPIVOT: 121,
    omekaIDarea: 132,
    omekaIDitinerario: 117,
    omekaIDpoi: 120,
    omekaIDtimeline: 124,
    omekaIDeventi: 127,
    omekaIDlivelliDifficolta: 129,
    omekaIDinteressi: 128,
    omekaIDstrumenti: 123,
    omekaIDmatriciSpostamenti: 31,
    availableTimeMorning: 6, //hours
    availableTimeAfternoon: 1, //hours
    availableTimeAllDay: 12, //hours
    meanTimeTravelBetweenPOI: 5, //minutes

    omekaIDambitoScientifico: 126, // Non è usato: è connesso a itinerario, ma non serve recuperare gli item di Ambito Scientifico

    omekaIDappartiene_a_itinerario: 213,

    timeSlots: [4, 6, 12], //4 ore, 6 ore, 12 ore

    defaultOrganizationTime: 10, // minuti di default di organizzazione di un'attività, se non è presente un alore specifico si usa questo
    defaultPreferredPartOfDay: "Indifferente",
    defaultTravelTimeBetweenAreas: 10, // minuti di default di spostamento tra un'area e l'altra
    defaultTravelTimeBetweenPOIs: 10, // minuti di default di spostamento tra un poi e l'altro
}

var varOmekaIDsIstitutoMosso = {
    omekaIDattivita: 124, //id aggiornato, da verificare
    omekaIDtipologiaAttivita: 136,  //id aggiornato, da verificare
    omekaIDluoghi: 125,
    omekaIDpoiPIVOT: 131,  //id aggiornato, da verificare
    omekaIDarea: 132,
    omekaIDitinerario: 128,  //id aggiornato, da verificare
    omekaIDpoi: 130,  //id aggiornato, da verificare
    omekaIDtimeline: 135, //OK è corretto
    omekaIDeventi: 126, //OK è corretto
    omekaIDlivelliDifficolta: 129,
    omekaIDinteressi: 128,
    omekaIDstrumenti: 134,  //OK è corretto
    omekaIDmatriciSpostamenti: 31,
    availableTimeMorning: 6, //hours
    availableTimeAfternoon: 1, //hours
    availableTimeAllDay: 12, //hours
    meanTimeTravelBetweenPOI: 5, //minutes

    omekaIDambitoScientifico: 122, 

    omekaIDappartiene_a_itinerario: 221,

    timeSlots: [4, 6, 12], //4 ore, 6 ore, 12 ore

    defaultOrganizationTime: 10, // minuti di default di organizzazione di un'attività, se non è presente un alore specifico si usa questo
    defaultPreferredPartOfDay: "Indifferente",
    defaultTravelTimeBetweenAreas: 10, // minuti di default di spostamento tra un'area e l'altra
    defaultTravelTimeBetweenPOIs: 10, // minuti di default di spostamento tra un poi e l'altro
}

if(config.isGeodidalab) {
    config.omekaIDs = varOmekaIDsGeodidalab;
} else {
    config.omekaIDs = varOmekaIDsIstitutoMosso;
}

export {config};